import React from 'react';
import {
  Button,
  ButtonGroup,
  Typography,
  Link,
  Form,
  TextField,
  useEmailAddressValidator,
  Divider,
} from '@ace-clublabs/shared-component-library';

interface Props {
  handleContinue: (values: any) => void;
  primaryEmail?: string | undefined;
  clubCode: string;
}

const UpdateEmailsForm: React.FC<Props> = ({ handleContinue, primaryEmail, clubCode }) => {
  const headerText = primaryEmail
    ? 'We will send a confirmation email to the address below'
    : 'Please enter an email address for the confirmation email';

  const validation = {
    'matches_regex[(^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$)|$^]': 'Please enter a valid email address.',
  };
  const getValidations = (primaryEmail?: string) => {
    const validations: any = { secondaryEmail: validation };
    if (!primaryEmail) validations['primaryEmail'] = { ...validation, required: 'Email address is required.' };
    return validations;
  };
  const getPrivacyPolicyUrl = () => {
    switch (clubCode) {
      case '188':
        return 'https://www.northampton.aaa.com/privacy-policy/';
      case '240':
        return 'https://northeast.aaa.com/general/privacy-policy.html';
      default:
        return 'https://www.ace.aaa.com/legal/privacy.html';
    }
  };

  const handleLinkClick = (url: string) => (event: any) => {
    event.preventDefault();
    window.open(url);
  };

  return (
    <div id="update-emails-form" className="inner-container">
      <Typography variant="h5Medium" id="update-emails-form-header" component="h1">
        {headerText}
      </Typography>
      <Form onSubmit={handleContinue}>
        <TextField
          id="primaryEmail"
          name="primaryEmail"
          className="margin24Bottom"
          label="Email address"
          disabled={!!primaryEmail}
          validator={useEmailAddressValidator()}
          defaultValue={primaryEmail}
        />
        <Divider className="margin24Bottom" />
        <Typography variant="b1Medium" id="secondaryEmail-header" className="margin8Bottom">
          Add another recipient
        </Typography>
        <TextField
          id="secondaryEmail"
          name="secondaryEmail"
          label="Email address (optional)"
          validator={useEmailAddressValidator({ label: 'Email address', required: false })}
        />
        <ButtonGroup>
          <Button
            variant="contained"
            id="emails-continue"
            className="margin16Bottom"
            type="submit"
            label="Continue"
          ></Button>
        </ButtonGroup>
        <Typography variant="b2Regular" id="privacy-policy-text" className="body-privacy-text">
          I agree to calls and texts, using automated technology, from or on AAA's behalf regarding membership
          products/services and offers. Consent is not a condition of purchase. Message and data rates may apply. I
          agree to the{' '}
          <Link id="privacy-policy-link" component="a" onClick={handleLinkClick(getPrivacyPolicyUrl())}>
            Privacy Policy
          </Link>
          ,{' '}
          <Link
            id="terms-and-conditions-link"
            component="a"
            onClick={handleLinkClick('https://www.ace.aaa.com/legal/terms-of-use.html')}
          >
            Terms & Conditions
          </Link>
          , and{' '}
          <Link
            id="text-terms-link"
            component="a"
            onClick={handleLinkClick('https://www.ace.aaa.com/legal/text-messaging-programs-terms-and-conditions.html')}
          >
            Text Terms
          </Link>
          .
        </Typography>
      </Form>
    </div>
  );
};

export default UpdateEmailsForm;
